module.exports = __webpack_public_path__ + "img/icon_right.d132bfab.svg";